var tasting_templates = {}

// #1
tasting_templates.scott = {
    name: `Scott Rao's Tasting Scoresheet`,
    steps: [
        {
            name: 'Taste Scoring',
            scoring: true,
            metrics: [
                {
                    name: 'Aroma',
                    weight: 1.5,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 7,
                        to: 10,
                        increment: 0.1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Acidity',
                    weight: 2.5,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 7,
                        to: 10,
                        increment: 0.1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Sweetness',
                    weight: 2.5,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 7,
                        to: 10,
                        increment: 0.1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Balance',
                    weight: 1.5,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 7,
                        to: 10,
                        increment: 0.1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Clean Cup',
                    weight: 2,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 7,
                        to: 10,
                        increment: 0.1,
                        counted: true,
                        scoreBox: true
                    }
                },

            ]
        },
    ]
}

// #1
tasting_templates.scott2 = {
    name: `Roast Defect Kit Cupping Scoresheet`,
    steps: [
        {
            name: 'Taste Scoring',
            scoring: true,
            metrics: [
                {
                    name: 'Aroma',
                    weight: 1.5,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 7,
                        to: 10,
                        increment: 0.1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Acidity',
                    weight: 2.5,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 7,
                        to: 10,
                        increment: 0.1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Sweetness',
                    weight: 2.5,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 7,
                        to: 10,
                        increment: 0.1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Balance',
                    weight: 1.5,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 7,
                        to: 10,
                        increment: 0.1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Clarity',
                    weight: 1,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 7,
                        to: 10,
                        increment: 0.1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Mouthfeel',
                    weight: 1,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 7,
                        to: 10,
                        increment: 0.1,
                        counted: true,
                        scoreBox: true
                    }
                },

            ]
        },
    ]
}

// #2
tasting_templates.coe = {
    name: `Cup of Excellence® Cupping Form`,
    addToScore: '36',
    steps: [
        {
            name: 'Taste Scoring',
            scoring: true,
            metrics: [
                {
                    name: 'Defects',
                    weight: -1,
                    scoring: {
                        type: 'number-magnitude-k',
                        number: {
                            name: '# cups',
                            min: 0,
                            max: 4,
                        },
                        magnitude: {
                            name: 'Intensity',
                            min: 0,
                            max: 3,
                        },
                        k: 4,
                        increment: 1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Clean Cup',
                    weight: 1,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 0,
                        to: 8,
                        increment: 0.1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Sweetness',
                    weight: 1,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 0,
                        to: 8,
                        increment: 0.1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Acidity',
                    weight: 1,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 0,
                        to: 8,
                        increment: 0.1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Mouth-Feel',
                    weight: 1,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 0,
                        to: 8,
                        increment: 0.1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Flavor',
                    weight: 1,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 0,
                        to: 8,
                        increment: 0.1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Aftertaste',
                    weight: 1,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 0,
                        to: 8,
                        increment: 0.1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Balance',
                    weight: 1,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 0,
                        to: 8,
                        increment: 0.1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Overall',
                    weight: 1,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 0,
                        to: 8,
                        increment: 0.1,
                        counted: true,
                        scoreBox: true
                    }
                },
            ]
        },
    ]
}

// #3
tasting_templates.barista_hustle = {
    name: `Barista Hustle Scoresheet`,
    steps: [
        {
            name: 'Taste Scoring',
            scoring: true,
            metrics: [
                {
                    name: 'Aroma',
                    weight: 1,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 7.5,
                        to: 10,
                        increment: 0.1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Flavour',
                    weight: 1,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 7.5,
                        to: 10,
                        increment: 0.1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Aftertaste',
                    weight: 1,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 7.5,
                        to: 10,
                        increment: 0.1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Acidity',
                    weight: 1,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 7.5,
                        to: 10,
                        increment: 0.1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Sweetness',
                    weight: 1,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 7.5,
                        to: 10,
                        increment: 0.1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Bitterness',
                    weight: 1,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 7.5,
                        to: 10,
                        increment: 0.1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Weight',
                    weight: 1,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 7.5,
                        to: 10,
                        increment: 0.1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Texture',
                    weight: 1,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 7.5,
                        to: 10,
                        increment: 0.1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Afterfeel',
                    weight: 1,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 7.5,
                        to: 10,
                        increment: 0.1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Balance',
                    weight: 1,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 7.5,
                        to: 10,
                        increment: 0.1,
                        counted: true,
                        scoreBox: true
                    }
                },
            ]
        },
    ]
}

// #4
tasting_templates.naughty_dog = {
    name: `Naughty Dog Cupping Template`,
    steps: [
        {
            name: 'Taste Scoring',
            scoring: true,
            metrics: [
                {
                    name: 'AROMA (Vůně)',
                    weight: 1,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 1,
                        to: 5,
                        increment: 1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'ACIDITY (Acidita)',
                    weight: 1,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 1,
                        to: 5,
                        increment: 1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'SWEETNESS (Sladkost)',
                    weight: 1,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 1,
                        to: 5,
                        increment: 1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'BODY (Tělo)',
                    weight: 1,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 1,
                        to: 5,
                        increment: 1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'TASTE (Chuť)',
                    weight: 1,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 1,
                        to: 5,
                        increment: 1,
                        counted: true,
                        scoreBox: true
                    }
                }
            ]
        },
    ]
}

// #5
tasting_templates.nomad = {
    name: `Nomad Coffee Customer Feedback`,
    steps: [
        {
            name: 'Taste Scoring',
            scoring: true,
            metrics: [
                {
                    name: 'Aroma',
                    weight: 2.5,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 1,
                        to: 10,
                        increment: 1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Acidity',
                    weight: 2.5,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 1,
                        to: 10,
                        increment: 1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Sweetness',
                    weight: 2.5,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 1,
                        to: 10,
                        increment: 1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Do you love it?',
                    weight: 2.5,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 1,
                        to: 10,
                        increment: 1,
                        counted: true,
                        scoreBox: true
                    }
                }
            ]
        },
    ]
}

// #6
tasting_templates.sca1 = {
    name: `Specialty Coffee Association Scoresheet`,
    steps: [
        {
            name: 'Taste Scoring',
            scoring: true,
            metrics: [
                {
                    name: 'Fragrance/Aroma',
                    weight: 1,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 6,
                        to: 10,
                        increment: 0.1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Flavor',
                    weight: 1,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 6,
                        to: 10,
                        increment: 0.1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Aftertaste',
                    weight: 1,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 6,
                        to: 10,
                        increment: 0.1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Acidity',
                    weight: 1,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 6,
                        to: 10,
                        increment: 0.1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Body',
                    weight: 1,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 6,
                        to: 10,
                        increment: 0.1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Balance',
                    weight: 1,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 6,
                        to: 10,
                        increment: 0.1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Uniformity',
                    weight: 2,
                    scoring: {
                        type: 'check-x-times-k',
                        x: 5,
                        k: 2,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Clean Cup',
                    weight: 2,
                    scoring: {
                        type: 'check-x-times-k',
                        x: 5,
                        k: 2,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Sweetness',
                    weight: 2,
                    scoring: {
                        type: 'check-x-times-k',
                        x: 5,
                        k: 2,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Defects',
                    weight: -1,
                    scoring: {
                        type: 'number-magnitude-k',
                        number: {
                            name: '# cups',
                            min: 0,
                            max: 5,
                        },
                        magnitude: {
                            name: 'Intensity',
                            min: 0,
                            max: 4,
                        },
                        k: 1,
                        increment: 1,
                        counted: true,
                        scoreBox: true
                    }
                },
                {
                    name: 'Overall',
                    weight: 1,
                    scoring: {
                        type: 'scale-horizontal',
                        from: 6,
                        to: 10,
                        increment: 0.1,
                        counted: true,
                        scoreBox: true
                    }
                }
            ]
        },
    ]
}

// tasting_templates.sca1 = {
//     name: `SCA Scoresheet`,
//     steps: [
//         {
//             name: 'Taste Scoring',
//             scoring: true,
//             metrics: [
//                 {
//                     name: 'Fragrance/Aroma',
//                     weight: 1,
//                     scoring: {
//                         type: 'scale-horizontal',
//                         from: 7,
//                         to: 10,
//                         increment: 0.1,
//                         counted: true,
//                         scoreBox: true
//                     }
//                 },
//                 {
//                     name: 'Flavor',
//                     weight: 1,
//                     scoring: {
//                         type: 'scale-horizontal',
//                         from: 1,
//                         to: 10,
//                         increment: 0.1,
//                         counted: true,
//                         scoreBox: true
//                     }
//                 },
//                 {
//                     name: 'Aftertaste',
//                     weight: 1,
//                     scoring: {
//                         type: 'scale-horizontal',
//                         from: 6,
//                         to: 10,
//                         increment: 0.1,
//                         counted: true,
//                         scoreBox: true
//                     }
//                 },
//                 {
//                     name: 'Acidity',
//                     weight: 1,
//                     scoring: {
//                         type: 'scale-horizontal',
//                         from: 6,
//                         to: 10,
//                         increment: 0.1,
//                         counted: true,
//                         scoreBox: true
//                     }
//                 },
//                 {
//                     name: 'Body',
//                     weight: 1,
//                     scoring: {
//                         type: 'scale-horizontal',
//                         from: 6,
//                         to: 10,
//                         increment: 0.1,
//                         counted: true,
//                         scoreBox: true
//                     }
//                 },
//                 {
//                     name: 'Balance',
//                     weight: 1,
//                     scoring: {
//                         type: 'scale-horizontal',
//                         from: 6,
//                         to: 10,
//                         increment: 0.1,
//                         counted: true,
//                         scoreBox: true
//                     }
//                 },
//                 {
//                     name: 'Overall',
//                     weight: 1,
//                     scoring: {
//                         type: 'scale-horizontal',
//                         from: 6,
//                         to: 10,
//                         increment: 0.1,
//                         counted: true,
//                         scoreBox: true
//                     }
//                 },
//                 {
//                     name: 'Defects',
//                     weight: -1,
//                     scoring: {
//                         type: 'number-magnitude-k',
//                         number: {
//                             name: '# cups',
//                             min: 0,
//                             max: 4,
//                         },
//                         magnitude: {
//                             name: 'Intensity',
//                             min: 0,
//                             max: 3,
//                         },
//                         k: 4,
//                         increment: 1,
//                         counted: true,
//                         scoreBox: true
//                     }
//                 },

//             ]
//         },
//         // {
//         //     name: 'Roast Level of Sample',
//         //     smallerDisplay: true,
//         //     scoring: true,
//         //     metrics: [
//         //         {
//         //             name: 'Roast Level',
//         //             scoring: {
//         //                 type: 'roast-level-vertical',
//         //                 from: 0,
//         //                 to: 10,
//         //                 increment: .1,
//         //             }
//         //         }

//         //     ]
//         // },
//         // {
//         //     name: 'Fragrance/Aroma',
//         //     scoring: true,
//         //     metrics: [
//         //         {
//         //             name: 'Fragrance/Aroma',
//         //             scoring: {
//         //                 type: 'scale-horizontal',
//         //                 from: 6,
//         //                 to: 10,
//         //                 increment: 0.1,
//         //                 counted: true,
//         //                 scoreBox: true
//         //             }
//         //         },
//         //         {
//         //             name: 'Dry',
//         //             scoring: {
//         //                 type: 'scale-vertical',
//         //                 from: 0,
//         //                 to: 10,
//         //                 increment: 0.1,
//         //             }
//         //         },
//         //         {
//         //             name: 'Qualities',
//         //             scoring: {
//         //                 type: 'descriptors-vertical',
//         //             }
//         //         },
//         //         {
//         //             name: 'Break',
//         //             scoring: {
//         //                 type: 'scale-vertical',
//         //                 from: 0,
//         //                 to: 10,
//         //                 increment: 0.1,
//         //             }
//         //         },

//         //     ]
//         // },
//         // {
//         //     name: 'Fragrance/Aroma',
//         //     metrics: [
//         //         {
//         //             name: 'Fragrance/Aroma',
//         //             scoring: {
//         //                 type: 'scale-horizontal',
//         //                 from: 6,
//         //                 to: 10,
//         //                 increment: 0.1,
//         //                 counted: true
//         //             }
//         //         },
//         //         {
//         //             name: 'Dry',
//         //             scoring: {
//         //                 type: 'scale-vertical',
//         //                 from: 0,
//         //                 to: 10,
//         //                 increment: 0.1,
//         //             }
//         //         },
//         //         {
//         //             name: 'Qualities',
//         //             scoring: {
//         //                 type: 'descriptors-vertical',
//         //             }
//         //         },
//         //         {
//         //             name: 'Break',
//         //             scoring: {
//         //                 type: 'scale-vertical',
//         //                 from: 0,
//         //                 to: 10,
//         //                 increment: 0.1,
//         //             }
//         //         },

//         //     ]
//         // },
//         // {
//         //     name: 'Flavor-1',
//         //     scoring: true,
//         //     metrics: [
//         //         {
//         //             name: 'Flavor',
//         //             scoring: {
//         //                 type: 'scale-horizontal',
//         //                 from: 6,
//         //                 to: 10,
//         //                 increment: 0.1,
//         //                 counted: true,
//         //                 scoreBox: true
//         //             }
//         //         },
//         //         {
//         //             name: 'Aftertaste',
//         //             scoring: {
//         //                 type: 'scale-horizontal',
//         //                 from: 6,
//         //                 to: 10,
//         //                 increment: 0.1,
//         //                 counted: true,
//         //                 scoreBox: true
//         //             }
//         //         },

//         //     ]
//         // },
//         // {
//         //     name: 'Acidity',
//         //     scoring: true,
//         //     metrics: [
//         //         {
//         //             name: 'Acidity',
//         //             scoring: {
//         //                 type: 'scale-horizontal',
//         //                 from: 6,
//         //                 to: 10,
//         //                 increment: 0.1,
//         //                 counted: true,
//         //                 scoreBox: true
//         //             }
//         //         },
//         //         {
//         //             name: 'Intensity',
//         //             scoring: {
//         //                 type: 'scale-vertical',
//         //                 from: 0,
//         //                 to: 10,
//         //                 increment: 0.1,
//         //             }
//         //         },

//         //     ]
//         // },
//     ]
// }


export default tasting_templates


// WEBPACK FOOTER //
// ./src/util/tasting_templates.js